import { defineStore } from 'pinia';

export const useScrollStore = defineStore('scroll', {
  state: () => ({
    isScrollEnd: false,
  }),
  actions: {
    setScrollEnd(status: boolean) {
      this.isScrollEnd = status;
    },
  },
});